import { createEventListenerManager } from "shared/lib/utils.js"

const { addListener: addEventListenerWithCleanup, cleanup } = createEventListenerManager() as {
  addListener: (element: Element | Document, event: string, handler: EventListener) => void
  cleanup: (() => void) & { withPageRestore: (restoreFn: () => void) => void }
}

// This component is responsible to the feature of every `ifttt-search` input has:
// - Show X icon when input is filled.
// - Clear input when X icon is clicked.
export const GenericSearchInputSetup = () => {
  // Helper function to clear search input and dispatch event
  const clearSearchInput = (searchWrapper: Element) => {
    const inputSearch = searchWrapper?.querySelector("input") as HTMLInputElement
    if (inputSearch) {
      inputSearch.value = ""
      window.dispatchEvent(new CustomEvent(`clean-search:${searchWrapper.id}`, {}))
    }
  }

  document.querySelectorAll(".icon.clean-search").forEach(cleanSearchButton => {
    addEventListenerWithCleanup(cleanSearchButton, "click", (event: MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()

      const searchWrapper = (event.target as Element).closest(".ifttt-search")
      if (searchWrapper) {
        clearSearchInput(searchWrapper)
      }
    })
  })

  // Add ESC key event listener to search inputs
  document.querySelectorAll(".ifttt-search input").forEach(searchInput => {
    addEventListenerWithCleanup(searchInput, "keydown", (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        const searchWrapper = (event.target as Element).closest(".ifttt-search")
        if (searchWrapper) {
          // When there is a highlighted item, don't clear the input. The highlighted item will be cleared instead on SearchHelperNavigation.
          const highlightedItem = searchWrapper.querySelector(".highlighted")
          if (!highlightedItem) {
            clearSearchInput(searchWrapper)
          }
        }
      }
    })
  })

  document.querySelectorAll(".ifttt-search a.search-navigation").forEach(footerLink => {
    const searchInput = footerLink.closest(".ifttt-search")?.querySelector("input")

    addEventListenerWithCleanup(searchInput, "input", (event: Event) => {
      const keyboardEvent = event as KeyboardEvent
      const searchTerm = (keyboardEvent.target as HTMLInputElement).value.trim()

      if (!searchTerm) return

      footerLink.href = `/search/query/${encodeURIComponent(searchTerm.toLowerCase())}`
    })
  })

  cleanup.withPageRestore(() => {
    GenericSearchInputSetup()
  })

  window.addEventListener("beforeunload", cleanup)
}
